module.exports = __webpack_public_path__ + "static/media/edit_blue_icon.2fa273bc.svg";